<template>
  <div>
  <v-toolbar flat color="white" dense style="margin-bottom:0px">
    <v-btn color="red" :disabled="selectedOrders.length==0" small>Mark as delivered</v-btn>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
  </v-toolbar>
  <v-data-table
            
            :headers="headers"
            v-model="selectedOrders"
            :items="orders"
            :search="search"
            :loading="true"
            item-key="id"
            dense
            class="elevation-1"
          >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
            
              <div
                class="subheading font-weight-light text-primary text--darken-3"
                v-text="header.text"
              />
               <div
                class="font-weight-light text--darken-4"
                v-text="header.desc"/>
            </template>
             
            <template
              slot="items"
              slot-scope="props"
              >
              <td>
               
              {{props.item.id}}</td>
              <td>
                <table>
                  <tr v-for="itm in props.item.items">
                    <td>{{itm.name}}</td>
                    <td> {{itm.label}}</td>
                    <td>{{itm.quantity}}</td> 
                  </tr>
                </table>
              </td>
              <td>{{props.item.address.name}} <br/>
               {{props.item.address.flatNo}} <br/>
             {{props.item.address.apartment}} <br/>
           {{props.item.address.street}} <br/>
         {{props.item.address.city}} - {{props.item.address.pincode}} <br/></td>
         <td>{{ props.item.payment_mode }}</td>
          <td class="text-left">{{ props.item.total }}</td>
              <td class="text-center">{{ props.item.created }}</td>
               <td class="text-center">{{ props.item.delivery_date }}</td>
                <td class="text-center">{{ props.item.delivery_time_slot }}</td>
            </template>
          </v-data-table>
      </div>
</template>
<script type="text/javascript">
  export default{
    data(){
      return{
    search:"",
    selectedOrders:[],
    headers: [],
    dialog:false,
  }
  },
    props:['orders'],
  methods:{
    al:function(){alert("hello")},
    markDelivered:function(){
      var ids=[]
      this.selectedOrders.forEach(i=>{
        ids.push(i.id)
      })
      this.$emit('updateState',{ids:ids,state:'4'})
      this.selectedOrders=[]
    }

  },
  created(){

    this.headers=[
    {
        sortable: false,
        text: 'Order Id',
        value: 'id'
      },
      {
        sortable: false,
        text: 'Items',
        value: 'items'
      },
      {
        sortable: false,
        text: 'Buyer Details',
        value: 'address'
      },
      {
        sortable: false,
        text: 'Payment Mode',
        value: 'payment_mode',
        align:"center"
      },
      {
        sortable: false,
        text: 'Amount',
        value: 'total',
        align:"center",
        desc:"subtotal + extra charges"
      },
      {
        sortable: false,
        text: 'Date',
        value: 'created',
        align:"center"
      },
      {
        sortable: false,
        text: 'Dispatch By',
        value: 'delivery_date',
        align:"center",
      },
      {
        sortable: false,
        text: 'Time Slot',
        value: 'delivery_time_slot',
        align:"center"
      }
      ];
      
      
      
  }
  }
</script>